// Auto-generated normalizer for table: Firmas
export function firmasNormalize(row) {
  return {
    idFirma: row.idFirma ?? row.IdFirma ?? row['IdFirma'] ?? 0,
    idEmpleado: row.idEmpleado ?? row.IdEmpleado ?? row['IdEmpleado'] ?? 0,
    firmaUrl: row.firmaUrl ?? row.FirmaUrl ?? row['FirmaUrl'] ?? '',
    fechaRegistro: row.fechaRegistro ?? row.FechaRegistro ?? row['FechaRegistro'] ?? null,
    fechaVigencia: row.fechaVigencia ?? row.FechaVigencia ?? row['FechaVigencia'] ?? null,
    esDirector: row.esDirector ?? row.EsDirector ?? row['EsDirector'] ?? false,
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
  };
}
